import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil';
import {
    Box,
    Grid,
    Typography,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    IconButton,
    FormHelperText
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchableDropdown from '../../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { isValidNumber, isValidPhoneNumber, removeKeysFromObj } from '../../../../utils/helper.jsx';
import { TempFormButtonsAtom, TempFormErrorsAtom, WhatsAppTempFormAtom } from '../../../../Services/_states/index.js';


const ButtonInputs = () => {
    const [ButtonTypeList, setButtonTypeList] = useState([
        {
            label: 'Quick reply buttons',
            options: [
                { label: 'Custom (Maximum 10 buttons)', type: 'QUICK_REPLY', isDisabled: false },
            ],
        },
        {
            label: 'Call-to-action buttons',
            options: [
                { label: 'Visit Website (Maximum 2 buttons)', type: 'URL', isDisabled: false },
                { label: 'Call Phone Number (Maximum 1 buttons)', type: 'PHONE_NUMBER', isDisabled: false },
                { label: 'Offer Code (Maximum 1 buttons)', type: 'OFFER_CODE', isDisabled: false },
            ],
        },
    ]);
    const [buttonArrayObj, setButtonArrayObj] = useRecoilState(TempFormButtonsAtom);
    const [formErrors, setFormErrors] = useRecoilState(TempFormErrorsAtom);
    const [formData, setFormData] = useRecoilState(WhatsAppTempFormAtom);
    const [selectedButton, setSelectedButton] = useState(null);

    const labelDisable = () => {
        let newCallActionArray = [...buttonArrayObj.callAction, ...buttonArrayObj.quickReply];
        let buttonTypes = [...ButtonTypeList];
        if (newCallActionArray.filter(btn => btn.type === 'QUICK_REPLY').length > 9) {
            buttonTypes[0].options[0] = { ...buttonTypes[0].options[0], isDisabled: true };
        } else buttonTypes[0].options[0] = { ...buttonTypes[0].options[0], isDisabled: false };

        if (newCallActionArray.filter(btn => btn.type === 'URL').length >= 2) {
            buttonTypes[1].options[0] = { ...buttonTypes[1].options[0], isDisabled: true };
        } else buttonTypes[1].options[0] = { ...buttonTypes[1].options[0], isDisabled: false };

        if (newCallActionArray.filter(btn => btn.type === 'PHONE_NUMBER').length >= 1) {
            buttonTypes[1].options[1] = { ...buttonTypes[1].options[1], isDisabled: true };
        } else buttonTypes[1].options[1] = { ...buttonTypes[1].options[1], isDisabled: false };

        if (newCallActionArray.filter(btn => btn.type === 'OFFER_CODE').length >= 1) {
            buttonTypes[1].options[2] = { ...buttonTypes[1].options[2], isDisabled: true };
        } else buttonTypes[1].options[2] = { ...buttonTypes[1].options[2], isDisabled: false };

        setButtonTypeList(buttonTypes)
    }

    const handleSelectButton = (e) => {
        if (e) {
            if (['QUICK_REPLY']?.includes(e?.type)) {
                let customBtn = [...buttonArrayObj?.quickReply, e];
                setButtonArrayObj({ ...buttonArrayObj, quickReply: customBtn })
            } else {
                setButtonArrayObj({ ...buttonArrayObj, callAction: [...buttonArrayObj?.callAction, e] })
            }
        }
    }
    const removeButtonObj = async (buttonObj, index) => {
        let updateBtnObj = {}
        if (buttonObj && ['QUICK_REPLY']?.includes(buttonObj?.type)) {
            let customBtn = buttonArrayObj?.quickReply?.filter((_, i) => i !== index);
            updateBtnObj = { ...buttonArrayObj, quickReply: customBtn };
        } else {
            let newCallActionArray = buttonArrayObj?.callAction?.filter((_, i) => i !== index);
            updateBtnObj = { ...buttonArrayObj, callAction: newCallActionArray };
        }
        setButtonArrayObj(updateBtnObj);
        let newBtnArr = await removeKeysFromObj([...updateBtnObj?.callAction, ...updateBtnObj?.quickReply], ['label', 'isDisabled']);
        let isButtonObj = formData?.components?.find(component => component?.type === 'BUTTONS');
        if (isButtonObj)
            setFormData({
                ...formData, components: formData?.components?.map(component =>
                    component.type === 'BUTTONS' ? { ...component, buttons: newBtnArr } : component
                )
            });
    }

    const handleChangeBtnText = async (value, type, index, field) => {
        let updateBtnObj = { ...buttonArrayObj };
        if (field === 'button') {
            let arr = [...updateBtnObj[type]];
            let obj = { ...arr[index], text: value };
            arr[index] = obj;
            updateBtnObj[type] = arr;
        }
        else if (field === 'url') {
            let arr = [...updateBtnObj[type]];
            let obj = { ...arr[index], url: value };
            arr[index] = obj;
            updateBtnObj[type] = arr;
        }
        else if (field === 'phone_number' && value?.length <= 20)
            if (isValidNumber(value) || !value) {
                let arr = [...updateBtnObj[type]];
                let obj = { ...arr[index], phone_number: value };
                arr[index] = obj;
                updateBtnObj[type] = arr;
            }

        let newBtnArr = await removeKeysFromObj([...updateBtnObj?.callAction, ...updateBtnObj?.quickReply], ['label', 'isDisabled']);
        setButtonArrayObj(updateBtnObj);
        let isButtonObj = formData?.components?.find(component => component?.type === 'BUTTONS');
        if (isButtonObj)
            setFormData({
                ...formData, components: formData?.components?.map(component =>
                    component.type === 'BUTTONS' ? { ...component, buttons: newBtnArr } : component
                )
            });
        else {
            let components = [...formData?.components];
            let obj = { type: 'BUTTONS', buttons: newBtnArr }
            setFormData({ ...formData, components: [...components, obj] })
        }
    }

    const handleSelectBtnType = (e, type, index, field = 'url') => {
        let updateBtnObj = { ...buttonArrayObj };
        if (e?.value === 'dynamic' && field === 'url') {
            let arr = [...updateBtnObj[type]];
            let obj = { ...arr[index], example: [''], url: "https://{{1}}" };
            arr[index] = obj;
            updateBtnObj[type] = arr;
        } else {
            let arr = [...updateBtnObj[type]];
            let obj = { ...arr[index], url: "https://" };
            delete obj?.example;
            arr[index] = obj;
            updateBtnObj[type] = arr;
        }
        setButtonArrayObj(updateBtnObj);
    }

    const handleChangeUrlParams = async (e, type, index, field = 'url') => {
        let updateBtnObj = { ...buttonArrayObj };
        let arr = [...updateBtnObj[type]];
        let obj = { ...arr[index], example: [e?.target?.value || ''] };
        arr[index] = obj;
        updateBtnObj[type] = arr;
        let newBtnArr = await removeKeysFromObj([...updateBtnObj?.callAction, ...updateBtnObj?.quickReply], ['label', 'isDisabled']);
        setButtonArrayObj(updateBtnObj);
        setFormData({
            ...formData, components: formData?.components?.map(component =>
                component.type === 'BUTTONS' ? { ...component, buttons: newBtnArr } : component
            )
        });
    }

    useEffect(() => {
        let ButtonArr = formData?.components?.find(component => component?.type === 'BUTTONS')?.buttons;
        if (ButtonArr) {
            let updateObj = { callAction: [], quickReply: [] }
            ButtonArr?.forEach(button => {
                if (button.type === "QUICK_REPLY") {
                    updateObj.quickReply.push(button);
                } else {
                    updateObj.callAction.push(button);
                }
            });
            setButtonArrayObj(updateObj)
        }
    }, [formData])

    useEffect(() => {
        labelDisable();
    }, [buttonArrayObj])

    return (

        <Box pt={3}>
            <Box>
                <Typography variant="h6">
                    Buttons
                    <Typography variant="body2" component="span" color="textSecondary" pl={2}>
                        (Optional)
                    </Typography>
                </Typography>

                <Grid container spacing={2} mt={1} mb={3}>
                    <Grid item xs={12} sm={4} md={4}>
                        <SearchableDropdown
                            label="Add Buttons +"
                            options={ButtonTypeList.flatMap(group =>
                                group.options.map(opt => ({
                                    ...opt,
                                    // groupLabel: group.label
                                }))
                            )}
                            labelKey="label"
                            valueKey="type"
                            value={selectedButton}
                            onChange={(val) => {
                                setSelectedButton(val);
                                if (val)
                                    handleSelectButton(val);
                            }}
                            getOptionDisabled={(option) => option?.isDisabled}
                            getOptionLabel={(option) => option?.label || option?.type}
                            isOptionEqualToValue={(option, value) => option?.type === value?.type}
                        />

                    </Grid>
                </Grid>

                {Object.entries(buttonArrayObj).length > 0 &&
                    Object.entries(buttonArrayObj).map(([buttonType, array]) => (
                        array?.length > 0 && (
                            <Box key={buttonType} mt={1} p={0} >
                                <Typography variant="h6" px={0}>
                                    {buttonType === 'callAction' ? 'Call to action' : 'Quick reply'}
                                </Typography>

                                {array.map((buttonObj, index) => {
                                    const textField = (
                                        <Box>
                                            <TextField
                                                size='small'
                                                label="Button Text"
                                                placeholder="Button Text"
                                                value={buttonObj?.text || ''}
                                                onChange={(e) => handleChangeBtnText(e.target.value, buttonType, index, 'button')}
                                                inputProps={{ maxLength: 25 }}
                                                error={Boolean(formErrors[`callActionBtn_text_${index}`] || formErrors[`quickReplyBtn_${index}`])}
                                                helperText={`${buttonObj?.text?.length || 0}/25 characters`}
                                            />
                                        </Box>
                                    );

                                    const removeBtn = (
                                        <IconButton onClick={() => removeButtonObj(buttonObj, index)}>
                                            <CloseIcon />
                                        </IconButton>
                                    );

                                    switch (buttonObj?.type) {
                                        case 'URL':
                                            return (
                                                <Grid container spacing={2} mt={0} p={2} key={index} sx={{ flexDirection: { xs: 'column', sm: 'row', md: 'row' }, }} >
                                                    <Grid item xs={12} sm={3}>
                                                        <SearchableDropdown
                                                            label="Visit Website"
                                                            options={[{ label: 'Visit Website', value: 'URL' }]}
                                                            value={{ label: 'Visit Website', value: 'URL' }}
                                                            onChange={() => { }}
                                                            disabled={true}
                                                            labelKey="label"
                                                            valueKey="value"
                                                        />

                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        {textField}</Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <SearchableDropdown
                                                            options={[{ label: "Static", value: "static" }, { label: "Dynamic", value: "dynamic" }]}
                                                            value={{ label: "Static", value: "static" }}
                                                            onChange={(e) => handleSelectBtnType(e, buttonType, index, 'url')}
                                                            placeholder="Select Type"

                                                        />
                                                        {/* <Select
                                                            fullWidth
                                                            defaultValue="static"
                                                            onChange={(e) => handleSelectBtnType(e, buttonType, index, 'url')}
                                                        >
                                                            <MenuItem value="static">Static</MenuItem>
                                                            <MenuItem value="dynamic">Dynamic</MenuItem>
                                                        </Select> */}
                                                    </Grid>
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            size='small'
                                                            label="Website Url"
                                                            placeholder="Website Url"
                                                            value={buttonObj?.url || ''}
                                                            onChange={(e) => handleChangeBtnText(e.target.value, buttonType, index, 'url')}
                                                            inputProps={{ maxLength: 2000 }}
                                                            error={Boolean(formErrors[`callActionBtn_url_${index}`])}
                                                            helperText={`${buttonObj?.url?.length || 0}/2000 characters`}
                                                        />
                                                        {buttonObj?.example?.length === 1 && (
                                                            <TextField
                                                                size='small'
                                                                placeholder="Enter Params"
                                                                value={buttonObj?.example[0] || ''}
                                                                onChange={(e) => handleChangeUrlParams(e, buttonType, index, 'url')}
                                                            />
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12} sm={1} sx={{ textAlign: 'end' }}>
                                                        {removeBtn}</Grid>
                                                    <hr style={{ width: "100%", marginBottom: 0, marginTop: "20px" }} />
                                                </Grid>
                                            );

                                        case 'PHONE_NUMBER':
                                            return (
                                                <Grid container spacing={2} mt={0} p={2} key={index} sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
                                                    <Grid item xs={12} sm={3}>
                                                        <SearchableDropdown
                                                            label="Call Phone Number"
                                                            options={[{ label: 'Call Phone Number', value: 'PHONE_NUMBER' }]}
                                                            value={{ label: 'Call Phone Number', value: 'PHONE_NUMBER' }}
                                                            onChange={() => { }}
                                                            disabled={true}
                                                            labelKey="label"
                                                            valueKey="value"
                                                        />

                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>{textField}</Grid>
                                                    <Grid item xs={12} sm={2}>

                                                        <SearchableDropdown
                                                            label="IN +91"
                                                            options={[{ label: 'IN +91', value: 'IN' }]}
                                                            value={{ label: 'IN +91', value: 'IN' }}
                                                            onChange={() => { }}
                                                            disabled={true}
                                                            labelKey="label"
                                                            valueKey="value"
                                                        />

                                                    </Grid>
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            size='small'
                                                            label="Phone Number"
                                                            placeholder="1236547890"
                                                            value={buttonObj?.phone_number || ''}
                                                            onChange={(e) => handleChangeBtnText(e.target.value, buttonType, index, 'phone_number')}
                                                            inputProps={{ maxLength: 20 }}
                                                            error={Boolean(formErrors[`callActionBtn_phone_number_${index}`])}
                                                            helperText={`${buttonObj?.phone_number?.length || 0}/20 characters`}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1} sx={{ textAlign: "end" }}>
                                                        {removeBtn}</Grid>
                                                    <hr style={{ width: "100%", marginBottom: 0, marginTop: "20px" }} />
                                                </Grid>
                                            );

                                        case 'OFFER_CODE':
                                            return (
                                                <Grid container spacing={2} mt={0} p={2} key={index} sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
                                                    <Grid item xs={12} sm={3}>
                                                        <SearchableDropdown
                                                            label="Copy Offer Code"
                                                            options={[{ label: 'Copy Offer Code', value: 'OFFER_CODE' }]}
                                                            value={{ label: 'Copy Offer Code', value: 'OFFER_CODE' }}
                                                            onChange={() => { }}
                                                            disabled={true}
                                                            labelKey="label"
                                                            valueKey="value"
                                                        />

                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        {textField}</Grid>
                                                    {/* <Grid item xs={2}></Grid> */}

                                                    <Grid item xs={12} sm={5}>                                                        <TextField
                                                        size='small'
                                                        label="Offer Code"
                                                        placeholder="Offer Code"
                                                        error={Boolean(formErrors[`callActionBtn_offerCode_${index}`])}
                                                    />
                                                    </Grid>
                                                    <Grid item xs={12} sm={1} sx={{ textAlign: "end" }}>{removeBtn}</Grid>
                                                    <hr style={{ width: "100%", marginBottom: 0, marginTop: "20px" }} />
                                                </Grid>
                                            );

                                        default:
                                            return (
                                                <Grid container spacing={2} mt={0} p={2} key={index}>
                                                    <Grid item xs={3}>{textField}</Grid>
                                                    {/* <Grid item xs={6}></Grid> */}
                                                    <Grid item xs={1}>{removeBtn}</Grid>
                                                    <hr style={{ width: "100%", marginBottom: 0, marginTop: "20px" }} />
                                                </Grid>
                                            );
                                    }
                                })}
                            </Box>
                        )
                    ))}
            </Box>
        </Box>
    );
};

export default ButtonInputs;